
import React from 'react';

type Props = {
    className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} width="24" height="24" viewBox="0 0 24 24" fill="none">
        <mask id="mask0_6055_4757" style={{maskType:'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
            <rect width="24" height="24" fill="currentcolor" />
        </mask>
        <g mask="url(#mask0_6055_4757)">
            <path d="M11.6667 15.6667L5 9H18.3333L11.6667 15.6667Z" fill="currentcolor" />
        </g>
    </svg>
);

export default Icon;



